var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelYoutube14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.12 3.5c.675.006 3.965.058 4.394.507.48.501.486 2.976.486 2.99 0 0-.004 2.489-.486 2.992-.43.448-3.719.504-4.395.51h-.107l-.014.001h-.121c-.676-.007-3.965-.063-4.395-.511C2.043 9.53 2.004 7.43 2 7.055v-.114c.004-.373.043-2.476.482-2.934.43-.449 3.719-.5 4.395-.506ZM5.5 5v4l4-2z"
}))));
export default SvgChannelYoutube14;